import { createAction } from 'redux-actions';

import getTypes from './types';

export default formStoreName => {
    const types = getTypes(formStoreName);

    const incrementItemsToShow = createAction(types.INCREMENT_ITEMS_TO_SHOW);
    const resetItemsToShow = createAction(types.RESET_ITEMS_TO_SHOW);
    const setItemsToShow = createAction(types.SET_ITEMS_TO_SHOW);

    return {
        incrementItemsToShow,
        resetItemsToShow,
        setItemsToShow,
    };
};
